import { HUB_RESOURCE_REGISTRY } from '../hub-resource-registry.js';
import { ICON_IDS } from '../routes/ids.js';
const presentation = Object.freeze({
    'platform-organizations': {
        listTitleKey: 'page.organization.title',
        createTitleKey: 'page.organization.createTitle',
        editTitleKey: 'page.organization.editTitle',
        detailTitleKey: 'page.organization.detail.title',
        descriptionKey: 'page.organization.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.platformOrganization.create',
        editFormDescriptorId: 'form.admin.platformOrganization.edit',
        viewFormDescriptorId: 'form.admin.platformOrganization.view',
    },
    'platform-modules': {
        listTitleKey: 'page.moduleAssignments.title',
        descriptionKey: 'page.moduleAssignments.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        bespokeReason: 'Module assignment uses a specialized permission composition surface.',
    },
    'platform-users': {
        listTitleKey: 'page.users.title',
        createTitleKey: 'page.users.createTitle',
        editTitleKey: 'page.users.editTitle',
        detailTitleKey: 'form.user.viewTitle',
        descriptionKey: 'page.users.description',
        iconKey: ICON_IDS.USERS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.user.create',
        editFormDescriptorId: 'form.admin.user.edit',
        viewFormDescriptorId: 'form.admin.user.view',
    },
    'platform-audit': {
        listTitleKey: 'page.audit.title',
        detailTitleKey: 'page.audit.detailTitle',
        descriptionKey: 'page.audit.description',
        iconKey: ICON_IDS.RECEIPT,
        i18nNamespace: 'admin',
        bespokeReason: 'Audit log viewing uses a dedicated read-only surface with specialized filtering and export.',
    },
    'platform-health': {
        listTitleKey: 'page.platformHealth.title',
        descriptionKey: 'page.platformHealth.description',
        iconKey: ICON_IDS.INFO,
        i18nNamespace: 'admin',
        bespokeReason: 'Platform health is a status composition rather than a CRUD resource.',
    },
    'platform-support-delegations': {
        listTitleKey: 'page.platformSupportDelegations.title',
        createTitleKey: 'page.platformSupportDelegations.createTitle',
        detailTitleKey: 'page.platformSupportDelegations.detailTitle',
        descriptionKey: 'page.platformSupportDelegations.description',
        iconKey: ICON_IDS.SECURITY,
        i18nNamespace: 'admin',
        bespokeReason: 'Support delegation requires a dedicated security workflow.',
    },
    'platform-maintenance-delegations': {
        listTitleKey: 'page.maintenanceDelegations.title',
        createTitleKey: 'page.maintenanceDelegations.createTitle',
        detailTitleKey: 'page.maintenanceDelegations.detailTitle',
        descriptionKey: 'page.maintenanceDelegations.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        bespokeReason: 'Maintenance delegation requires a dedicated governance workflow with time-based scoping.',
    },
    'platform-access-inspector': {
        listTitleKey: 'page.platformAccessInspector.title',
        descriptionKey: 'page.platformAccessInspector.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        bespokeReason: 'Access inspection is a policy explanation surface.',
    },
    'organization-profile': {
        listTitleKey: 'page.organization.title',
        editTitleKey: 'page.organization.editTitle',
        detailTitleKey: 'page.organization.detail.title',
        descriptionKey: 'page.organization.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'admin',
        editFormDescriptorId: 'form.admin.organizationProfile.edit',
        viewFormDescriptorId: 'form.admin.organizationProfile.view',
    },
    'organization-branches': {
        listTitleKey: 'page.branches.title',
        createTitleKey: 'page.branches.createTitle',
        editTitleKey: 'page.branches.editTitle',
        detailTitleKey: 'page.branches.detailTitle',
        descriptionKey: 'page.branches.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.branch.create',
        editFormDescriptorId: 'form.admin.branch.edit',
        viewFormDescriptorId: 'form.admin.branch.view',
    },
    'organization-module-activations': {
        listTitleKey: 'page.moduleAssignments.title',
        createTitleKey: 'page.moduleAssignments.createTitle',
        editTitleKey: 'page.moduleAssignments.editTitle',
        descriptionKey: 'page.moduleAssignments.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.moduleAssignment.create',
        editFormDescriptorId: 'form.admin.moduleAssignment.edit',
        viewFormDescriptorId: 'form.admin.moduleAssignment.view',
    },
    'organization-users': {
        listTitleKey: 'page.users.title',
        createTitleKey: 'page.users.createTitle',
        editTitleKey: 'page.users.editTitle',
        detailTitleKey: 'form.user.viewTitle',
        descriptionKey: 'page.users.description',
        iconKey: ICON_IDS.USERS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.user.create',
        editFormDescriptorId: 'form.admin.user.edit',
        viewFormDescriptorId: 'form.admin.user.view',
    },
    'organization-roles': {
        listTitleKey: 'page.roles.title',
        createTitleKey: 'page.roles.createTitle',
        editTitleKey: 'page.roles.editTitle',
        detailTitleKey: 'form.role.viewTitle',
        descriptionKey: 'page.roles.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.role.create',
        editFormDescriptorId: 'form.admin.role.edit',
        viewFormDescriptorId: 'form.admin.role.view',
    },
    'organization-permission-assignments': {
        listTitleKey: 'page.permissionAssignments.title',
        editTitleKey: 'page.permissionAssignments.editTitle',
        descriptionKey: 'page.permissionAssignments.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        bespokeReason: 'Permission assignment requires actor-ceiling and conflict visualization.',
    },
    'organization-clients': {
        listTitleKey: 'page.clients.title',
        createTitleKey: 'page.clients.createTitle',
        editTitleKey: 'page.clients.editTitle',
        detailTitleKey: 'page.clients.detailTitle',
        descriptionKey: 'page.clients.description',
        iconKey: ICON_IDS.USERS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.client.create',
        editFormDescriptorId: 'form.admin.client.edit',
        viewFormDescriptorId: 'form.admin.client.view',
    },
    'organization-client-accounts': {
        listTitleKey: 'page.clientAccounts.title',
        createTitleKey: 'page.clientAccounts.createTitle',
        editTitleKey: 'page.clientAccounts.editTitle',
        detailTitleKey: 'page.clientAccounts.detailTitle',
        descriptionKey: 'page.clientAccounts.description',
        iconKey: ICON_IDS.USERS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.clientAccount.create',
        editFormDescriptorId: 'form.admin.clientAccount.edit',
        viewFormDescriptorId: 'form.admin.clientAccount.view',
    },
    'organization-portfolios': {
        listTitleKey: 'page.portfolios.title',
        createTitleKey: 'page.portfolios.createTitle',
        editTitleKey: 'page.portfolios.editTitle',
        detailTitleKey: 'page.portfolios.detailTitle',
        descriptionKey: 'page.portfolios.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.portfolio.create',
        editFormDescriptorId: 'form.admin.portfolio.edit',
        viewFormDescriptorId: 'form.admin.portfolio.view',
    },
    'organization-audit': {
        listTitleKey: 'page.audit.title',
        detailTitleKey: 'page.audit.detailTitle',
        descriptionKey: 'page.audit.description',
        iconKey: ICON_IDS.RECEIPT,
        i18nNamespace: 'admin',
        bespokeReason: 'Audit log viewing uses a dedicated read-only surface with specialized filtering and export.',
    },
    'organization-access-inspector': {
        listTitleKey: 'page.organizationAccessInspector.title',
        descriptionKey: 'page.organizationAccessInspector.description',
        iconKey: ICON_IDS.LOCK,
        i18nNamespace: 'admin',
        bespokeReason: 'Access inspection is a policy explanation surface.',
    },
    'organization-jurisdiction-settings': {
        listTitleKey: 'page.jurisdictionSettings.title',
        descriptionKey: 'page.jurisdictionSettings.description',
        iconKey: ICON_IDS.PERSON,
        i18nNamespace: 'admin',
        bespokeReason: 'Jurisdiction settings is a bespoke configuration surface for market calendar and regulatory parameters.',
    },
    'organization-opening-cutover': {
        listTitleKey: 'page.openingCutover.title',
        descriptionKey: 'page.openingCutover.description',
        iconKey: ICON_IDS.BATCH,
        i18nNamespace: 'accounting',
        createFormDescriptorId: 'form.admin.openingCutover.create',
        editFormDescriptorId: 'form.admin.openingCutover.edit',
        viewFormDescriptorId: 'form.admin.openingCutover.view',
        rowActivationField: 'id',
    },
    'organization-opening-cutover-history': {
        listTitleKey: 'page.openingCutoverHistory.title',
        descriptionKey: 'page.openingCutoverHistory.description',
        iconKey: ICON_IDS.HISTORY,
        i18nNamespace: 'accounting',
        viewFormDescriptorId: 'form.admin.openingCutover.view',
        rowActivationField: 'id',
    },
    'organization-tax-rules': {
        listTitleKey: 'page.taxRules.title',
        descriptionKey: 'page.taxRules.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.taxRule.create',
        editFormDescriptorId: 'form.admin.taxRule.edit',
        viewFormDescriptorId: 'form.admin.taxRule.view',
        rowActivationField: 'id',
    },
    'organization-fee-rules': {
        listTitleKey: 'page.feeRules.title',
        descriptionKey: 'page.feeRules.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'admin',
        createFormDescriptorId: 'form.admin.feeRule.create',
        editFormDescriptorId: 'form.admin.feeRule.edit',
        viewFormDescriptorId: 'form.admin.feeRule.view',
        rowActivationField: 'id',
    },
    transactions: {
        listTitleKey: 'page.transactions.title',
        createTitleKey: 'form.transaction.createTitle',
        detailTitleKey: 'transaction.detail.title',
        descriptionKey: 'transaction.form.description.create',
        iconKey: ICON_IDS.TRANSACTIONS,
        i18nNamespace: 'transaction',
        createFormDescriptorId: 'form.transaction.create',
        rowActivationField: 'id',
        bespokeReason: 'Transaction lifecycle actions remain on the dedicated investment workflow surface.',
    },
    instruments: {
        listTitleKey: 'page.instruments.title',
        createTitleKey: 'form.instrument.createTitle',
        editTitleKey: 'form.instrument.editTitle',
        detailTitleKey: 'page.instruments.detail.title',
        descriptionKey: 'page.instruments.description',
        iconKey: ICON_IDS.HOLDINGS,
        i18nNamespace: 'investment',
        createFormDescriptorId: 'form.data.instrument.create',
        editFormDescriptorId: 'form.data.instrument.edit',
        viewFormDescriptorId: 'form.data.instrument.view',
        rowActivationField: 'symbol',
    },
    'market-prices': {
        listTitleKey: 'card.marketPrices.title',
        detailTitleKey: 'page.marketPrices.detail.title',
        descriptionKey: 'card.marketPrices.description',
        iconKey: ICON_IDS.REPORTS,
        i18nNamespace: 'data',
        rowActivationField: 'id',
    },
    'corporate-actions': {
        listTitleKey: 'page.corporateActions.title',
        detailTitleKey: 'page.corporateActions.detail.title',
        descriptionKey: 'page.corporateActions.description',
        iconKey: ICON_IDS.CORPORATE_ACTIONS,
        i18nNamespace: 'investment',
        createFormDescriptorId: 'form.data.corporateAction.create',
        editFormDescriptorId: 'form.data.corporateAction.edit',
        viewFormDescriptorId: 'form.data.corporateAction.view',
    },
    'fact-batches': {
        listTitleKey: 'page.factBatches.title',
        detailTitleKey: 'page.factBatches.detail.title',
        descriptionKey: 'page.factBatches.description',
        iconKey: ICON_IDS.BATCH,
        i18nNamespace: 'investment',
    },
    'import-jobs': {
        listTitleKey: 'page.imports.title',
        createTitleKey: 'form.importJob.title',
        detailTitleKey: 'page.imports.detail.title',
        descriptionKey: 'page.imports.description',
        iconKey: ICON_IDS.IMPORT,
        i18nNamespace: 'data',
        createFormDescriptorId: 'form.importJob.create',
    },
    'reconciliation-runs': {
        listTitleKey: 'page.reconciliation.title',
        detailTitleKey: 'page.reconciliation.detail.title',
        descriptionKey: 'page.reconciliation.description',
        iconKey: ICON_IDS.RECONCILIATION,
        i18nNamespace: 'reconciliation',
        rowActivationField: 'runId',
    },
    holdings: {
        listTitleKey: 'page.holdings.title',
        detailTitleKey: 'page.holdings.detail.title',
        descriptionKey: 'page.holdings.description',
        iconKey: ICON_IDS.HOLDINGS,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    'cash-positions': {
        listTitleKey: 'card.cash.title',
        descriptionKey: 'card.cash.description',
        iconKey: ICON_IDS.DATA,
        i18nNamespace: 'investment',
    },
    clients: {
        listTitleKey: 'card.clientsData.title',
        detailTitleKey: 'card.clientsData.title',
        descriptionKey: 'card.clientsData.description',
        iconKey: ICON_IDS.USERS,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    portfolios: {
        listTitleKey: 'card.portfoliosData.title',
        detailTitleKey: 'card.portfoliosData.title',
        descriptionKey: 'card.portfoliosData.description',
        iconKey: ICON_IDS.BUSINESS,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    positions: {
        listTitleKey: 'card.positions.title',
        descriptionKey: 'card.positions.description',
        iconKey: ICON_IDS.HOLDINGS,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    journals: {
        listTitleKey: 'card.journals.title',
        detailTitleKey: 'card.journals.title',
        descriptionKey: 'card.journals.description',
        iconKey: ICON_IDS.RECEIPT,
        i18nNamespace: 'accounting',
        rowActivationField: 'id',
    },
    'fiscal-periods': {
        listTitleKey: 'card.fiscalPeriods.title',
        descriptionKey: 'card.fiscalPeriods.description',
        iconKey: ICON_IDS.BATCH,
        i18nNamespace: 'accounting',
        rowActivationField: 'id',
    },
    'fiscal-years': {
        listTitleKey: 'card.fiscalYears.title',
        detailTitleKey: 'card.fiscalYears.title',
        descriptionKey: 'card.fiscalYears.description',
        iconKey: ICON_IDS.BATCH,
        i18nNamespace: 'accounting',
        rowActivationField: 'id',
    },
    'performance-series': {
        listTitleKey: 'card.performance.title',
        descriptionKey: 'card.performance.description',
        iconKey: ICON_IDS.REPORTS,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    'tax-records': {
        listTitleKey: 'card.taxRecords.title',
        descriptionKey: 'card.taxRecords.description',
        iconKey: ICON_IDS.RECEIPT,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    'risk-exposures': {
        listTitleKey: 'card.riskExposures.title',
        descriptionKey: 'card.riskExposures.description',
        iconKey: ICON_IDS.WARNING,
        i18nNamespace: 'investment',
        rowActivationField: 'instrumentSymbol',
    },
    'compliance-breaches': {
        listTitleKey: 'card.complianceBreaches.title',
        descriptionKey: 'card.complianceBreaches.description',
        iconKey: ICON_IDS.WARNING,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
    },
    'position-transfers': {
        listTitleKey: 'card.positionTransfers.title',
        descriptionKey: 'card.positionTransfers.description',
        iconKey: ICON_IDS.TRANSACTIONS,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
        bespokeReason: 'Position transfer request/approve/execute/cancel/reverse lifecycle actions remain on the dedicated investment workflow surface.',
    },
    'settlement-instructions': {
        listTitleKey: 'card.settlementInstructions.title',
        descriptionKey: 'card.settlementInstructions.description',
        iconKey: ICON_IDS.RECEIPT,
        i18nNamespace: 'investment',
        rowActivationField: 'id',
        bespokeReason: 'Settlement confirm/correct/cancel lifecycle actions remain on the dedicated settlement workflow surface.',
    },
});
function translationKey(value) {
    return value;
}
function buildResourceDescriptor(resourceId) {
    const resource = HUB_RESOURCE_REGISTRY[resourceId];
    const display = presentation[resourceId];
    if (!resource)
        throw new Error(`Unknown hub resource: ${resourceId}`);
    if (!display)
        throw new Error(`Resource ${resourceId} has no canonical experience presentation.`);
    return Object.freeze({
        ...resource,
        id: resource.id,
        listTitleKey: translationKey(display.listTitleKey),
        createTitleKey: translationKey(display.createTitleKey),
        editTitleKey: translationKey(display.editTitleKey),
        detailTitleKey: translationKey(display.detailTitleKey),
        descriptionKey: translationKey(display.descriptionKey),
        iconKey: display.iconKey,
        i18nNamespace: display.i18nNamespace,
        createFormDescriptorId: display.createFormDescriptorId,
        editFormDescriptorId: display.editFormDescriptorId,
        viewFormDescriptorId: display.viewFormDescriptorId,
        detailDescriptorId: display.detailDescriptorId,
        rowActivationField: display.rowActivationField ??
            (resource.rowActivation === 'DETAIL' || resource.rowActivation === 'EDIT' ? 'id' : undefined),
        readOnly: !(resource.createOperationId ||
            resource.updateOperationId ||
            resource.deleteOperationId),
        bespokeReason: display.bespokeReason ?? (resource.bespokeReason),
    });
}
export const EXPERIENCE_RESOURCE_REGISTRY = Object.freeze(Object.fromEntries(Object.keys(HUB_RESOURCE_REGISTRY).map((resourceId) => [
    resourceId,
    buildResourceDescriptor(resourceId),
])));
export function getExperienceResourceDescriptor(resourceId) {
    return EXPERIENCE_RESOURCE_REGISTRY[resourceId];
}
